<template>
  <b-modal id="modal-excluir-lista" dialog-class="modal-conta" hide-footer :no-enforce-focus="true" centered>
    <template slot="modal-header">
      <h5 class="modal-title">Excluir lista de usuários</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-excluir-lista')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div class="row">
      <div class="col-12 col-md">
        <strong style="color:red;" v-if="!total">O arquivo deve conter os emails, um em cada linha.</strong>
      </div>
    </div>

    <div class="form-group mt-4 mb-2">
      <label for="excluir-lista" class="sr-only">Excluir lista de usuários</label>
      <p style="text-align:center;font-size:large;" v-if="total"> Arquivo: <strong> {{file.name}} </strong></p>
      <input type="file" v-if="!total" class="form-control-file" id="excluir-lista" ref="file" v-on:change="handleFileUpload">
    </div>

    <div class="text-center">
      <div class="d-flex align-items-center justify-content-center mt-5 mb-4">
        <a href="javascript:void(0)" class="btn btn-primary mr-3" v-if="total" @click="excluirUsuarios">Excluir<span> {{total}} alunos</span></a>
        <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-excluir-lista')">Cancelar</a>
      </div>
    </div>

    <div>
      <textarea class="form-control" rows="10" v-model="text" v-if="text" readonly></textarea>
    </div>
  </b-modal>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import UrlUtils from '@/core/util/url-utils'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalExclusaoUsuarios',
  data () {
    return {
      file: null,
      baseFile: UrlUtils.obterUrlCompleta('/template/import_usuarios_template.csv'),
      text: '',
      total: ''
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.file = null
      this.text = ''
      this.total = ''
    })
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-excluir-lista')
    },

    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      let reader = new FileReader()
      reader.readAsText(this.file, 'UTF-8')
      reader.onload = evt => {
        this.text = evt.target.result
        this.total = this.text.split(/\r\n|\r|\n/).length
      }
    },

    excluirUsuarios: function () {
      if (!this.file) {
        Swal.fire({
          icon: 'error',
          text: 'Obrigatório informar o arquivo para exclusão'
        })
        return
      }
      const loader = this.$loading.show()

      UsuarioAPI.excluirUsuarios(this.file).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Usuários excluídos!'
        }).then(() => {
          this.$bvModal.hide('modal-excluir-lista')
          this.$emit('usuariosExcluidos')
        })
      }).catch(error => ResponseUtils.handleError(error))
    }
  }
}
</script>

<style scoped>

</style>
